const SvgIcon = ({ name, width, height }) => {
  const svgns = 'http://www.w3.org/2000/svg';
  const xlinkns = 'http://www.w3.org/1999/xlink';

  let svgElement = document.createElementNS(svgns, 'svg');
  let svgUse = document.createElementNS(svgns, 'use');

  svgElement.setAttribute('width', width || 16);
  svgElement.setAttribute('height', height || 16);

  svgUse.setAttributeNS(xlinkns, 'href', `#${name}`);
  svgElement.appendChild(svgUse);

  return svgElement;
};

export default SvgIcon;
